'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@newfront-insurance/core-ui/v2';
import { motion } from 'framer-motion';
interface Props {
  show: boolean;
}
export function ThinkingMessage(t0) {
  const $ = _c(6);
  const {
    show
  } = t0;
  const t1 = !show;
  let t2;
  if ($[0] !== t1) {
    t2 = cn("group/message mx-auto w-full max-w-3xl px-8", {
      invisible: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("flex w-full items-center gap-4 rounded-lg", "group-data-[role=user]/message:ml-auto group-data-[role=user]/message:w-fit", "group-data-[role=user]/message:max-w-3xl group-data-[role=user]/message:px-3", "group-data-[role=user]/message:bg-muted group-data-[role=user]/message:py-2");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={t3}><div className="flex items-center gap-2">{[0, 1, 2].map(_temp)}</div></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2) {
    t5 = <motion.div data-testid="message-assistant-loading" className={t2} data-role="assistant">{t4}</motion.div>;
    $[4] = t2;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function _temp(i) {
  return <motion.div key={i} className="bg-steel-200 size-2 rounded-full" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 0.5
  }} transition={{
    repeat: Infinity,
    repeatType: "reverse",
    duration: 0.8,
    delay: i * 0.2,
    ease: "easeInOut"
  }} />;
}